import React, { Component } from "react";
import { Checkbox } from "react-bootstrap";
import Datetime from "react-datetime";
import moment from "moment";

import translator from "../../../components/localization/translator";
import InputWithLabel from "../../../components/common/elements/InputWithLabel";
import CheckboxGroup from "../../../components/common/elements/CheckboxGroup";
import FormInput from "../../../components/common/elements/FormInput";

import { NON_WORKING_DAYS, PAYMENT_METHODS } from "../../../config/constants";

class commonInformation extends Component {
    renderFormInput(
        label,
        name,
        value,
        validations,
        changeHandler,
        inputStyle
    ) {
        return (
            <FormInput
                label={label}
                id={name}
                name={name}
                onChange={changeHandler}
                value={value}
                validations={validations.validations}
                validationErrors={validations.validationErrors}
                required={validations.required}
                validationError={
                    validations.required
                        ? translator.translate("_required_field_")
                        : ""
                }
                disabled={validations.disabled}
                inputStyle={inputStyle}
            />
        );
    }

    renderInput(
        label,
        id,
        type,
        value,
        onChange,
        labelStyle,
        inputStyle,
        dotsAllowed
    ) {
        return (
            <InputWithLabel
                htmlFor={id}
                label={label}
                type={type}
                id={id}
                value={value || ""}
                onChange={onChange}
                labelStyle={labelStyle}
                inputStyle={inputStyle}
                dotsAllowed={dotsAllowed}
            />
        );
    }

    renderRestaurantPhoneNumbers(
        label,
        name,
        value,
        validations,
        changeHandler
    ) {
        return (
            <div className="display-flex">
                <label className={"label-width"}>
                    {translator.translate(label)}:
                </label>
                <div className="flex-box direction-column">
                    {(value || []).map((phone, index) => {
                        const iconName = index > 0 ? "minus" : "plus";
                        return (
                            <div key={index}>
                                <div className="form-group margin-bottom">
                                    <span className="flex-box">
                                        {this.renderFormInput(
                                            "",
                                            name,
                                            phone,
                                            validations,
                                            (e) => {
                                                changeHandler(e, index);
                                            }
                                        )}
                                        <span
                                            className={`glyphicon glyphicon-${iconName}-sign left-distance red-color pointer span-padding-top`}
                                            onClick={() => {
                                                if ("plus" === iconName) {
                                                    let NewPhone = "";
                                                    value.push(NewPhone);
                                                    this.renderFormInput(
                                                        "",
                                                        name,
                                                        phone,
                                                        validations,
                                                        (e) => {
                                                            changeHandler(
                                                                e,
                                                                index
                                                            );
                                                        }
                                                    );
                                                } else if (
                                                    "minus" === iconName
                                                ) {
                                                    if (value.length > 1) {
                                                        value.splice(index, 1);
                                                    }
                                                }
                                                this.forceUpdate();
                                            }}
                                        ></span>
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    nameHandler(label, name, value, validations, changeHandler) {
        return this.renderFormInput(
            label,
            name,
            value,
            validations,
            changeHandler
        );
    }

    branchKeyHandler(label, name, value, validations, changeHandler) {
        return this.renderFormInput(
            label,
            name,
            value,
            validations,
            changeHandler
        );
    }

    renderRestaurantAddress(label, name, value, validations, changeHandler) {
        return this.renderFormInput(
            label,
            name,
            value,
            validations,
            changeHandler
        );
    }

    renderRestaurantAditionalHint(
        label,
        name,
        value,
        validations,
        changeHandler
    ) {
        return this.renderFormInput(
            label,
            name,
            value,
            validations,
            changeHandler
        );
    }

    renderCoordinates(names, coordinates, changeHandlers) {
        const lat = coordinates && coordinates.lat ? coordinates.lat : 0;
        const lng = coordinates && coordinates.lng ? coordinates.lng : 0;
        return (
            <div className="display-flex align-center">
                <label className={"label-width"}>
                    {translator.translate("_coordinates_")}:
                </label>
                <div
                    htmlFor={"coordinates"}
                    className="my-custom-input margin-to-left"
                >
                    <div className="display-flex">
                        <div className="margin-right">
                            {this.renderInput(
                                "_lat_",
                                names.lat,
                                "number",
                                lat,
                                changeHandlers.lat,
                                "lat-padding",
                                "",
                                true
                            )}
                        </div>
                        <div className="margin-right">
                            {this.renderInput(
                                "_lng_",
                                names.lng,
                                "number",
                                lng,
                                changeHandlers.lng,
                                "lng-padding",
                                "",
                                true
                            )}
                        </div>
                    </div>
                    {(!lat || !lng) && (
                        <div
                            className={
                                "validation-error distance-field default-font red-color"
                            }
                        >
                            {translator.translate("_required_field_")}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderDateTimeInput(label, id, value, formats, handler, validationHandler) {
        value = value ? moment(value).format(formats.dataFormat) : "";
        return (
            <div className="display-flex align-center margin-right">
                <label className={"label-width"}>
                    {translator.translate(label)}:
                </label>
                <Datetime
                    id={id}
                    value={value}
                    onChange={(e) => {
                        handler(e);
                    }}
                    dateFormat={formats.dateFormat}
                    timeFormat={formats.timeFormat}
                    isValidDate={validationHandler}
                    className="default-font my-custom-input"
                    inputProps={{
                        onKeyPress: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        },
                    }}
                />
            </div>
        );
    }

    renderWorkingHours(names, workingHours, changeHandlers) {
        const formats = {
            dataFormat: "HH:mm",
            dateFormat: false,
            timeFormat: "HH:mm",
        };
        const start =
            workingHours && workingHours.start ? workingHours.start : "";
        const end = workingHours && workingHours.end ? workingHours.end : "";
        return (
            <div className="display-flex align-center">
                <label htmlFor={"workingHours"} className={"label-width"}>
                    {translator.translate("_working_hours_")}:
                </label>
                <div className="display-flex my-custom-input margin-to-left">
                    {this.renderDateTimeInput(
                        "_start_",
                        names.start,
                        start,
                        formats,
                        changeHandlers.start,
                        (current) => {
                            return true;
                        }
                    )}
                    {this.renderDateTimeInput(
                        "_end_",
                        names.end,
                        end,
                        formats,
                        changeHandlers.end,
                        (current) => {
                            return true;
                        }
                    )}
                </div>
            </div>
        );
    }

    renderDeliveryService(names, data, changeHandlers) {
        const {
            isDeliveryServiceProvision,
            supplierDeliveryTariff,
            supplierDeliveryTariff2nd,
            preparationAverageTime,
            deliveryAverageTime,
            paymentOption,
        } = data;

        return (
            <div>
                <div className="display-flex">
                    <label className={`label-width`}>
                        {translator.translate("_delivery_service_provision_")}:
                    </label>
                    <div className="my-custom-input margin-to-left">
                        <Checkbox
                            className="margin-bottom order-margin"
                            checked={isDeliveryServiceProvision}
                            onChange={(e) => {
                                changeHandlers.isDeliveryServiceProvision(e);
                                this.forceUpdate();
                            }}
                        />
                    </div>
                </div>
                <div className="display-flex">
                    <div className="delivery-service-item margin-right">
                        {this.renderInput(
                            "_supplier_delivery_tariff_",
                            names.supplierDeliveryTariff,
                            "number",
                            supplierDeliveryTariff,
                            changeHandlers.supplierDeliveryTariff,
                            "tariff-input-label",
                            "tariff-input",
                            true
                        )}
                    </div>
                    <div className="delivery-service-item">
                        {this.renderInput(
                            "_supplier_delivery_tariff_2nd_",
                            names.supplierDeliveryTariff2nd,
                            "number",
                            supplierDeliveryTariff2nd,
                            changeHandlers.supplierDeliveryTariff2nd,
                            "tariff-input-label",
                            "tariff-input",
                            true
                        )}
                    </div>
                </div>
                <div className="display-flex">
                    <div className="delivery-service-item margin-right">
                        {this.renderInput(
                            "_preparation_average_time_",
                            names.preparationAverageTime,
                            "number",
                            preparationAverageTime,
                            changeHandlers.preparationAverageTime,
                            "tariff-input-label",
                            "tariff-input",
                            true
                        )}
                    </div>
                    <div className="delivery-service-item margin-right">
                        {this.renderInput(
                            "_delivery_average_time_",
                            names.deliveryAverageTime,
                            "number",
                            deliveryAverageTime,
                            changeHandlers.deliveryAverageTime,
                            "tariff-input-label",
                            "tariff-input",
                            true
                        )}
                    </div>
                </div>
                <div className="display-flex">
                    <label className={`label-width`}>
                        {translator.translate("_payment_option_")}:
                    </label>
                    <div className="my-custom-input margin-to-left display-flex direction-column">
                        {PAYMENT_METHODS.map((item, index) => {
                            const isChecked =
                                paymentOption &&
                                paymentOption.includes(item.id);
                            return this.renderCheckboxGroup(
                                item.name,
                                item.id,
                                isChecked,
                                (e, id) => {
                                    changeHandlers.paymentOption(e, id);
                                    this.forceUpdate();
                                }
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    renderSupplierSystemIntegration(value, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_supplier_system_integration_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={value}
                        onChange={(e) => {
                            changeHandler(e);
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderProductManagement(value, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_products_management_")}
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={value}
                        onChange={(e) => {
                            changeHandler(e);
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderHolidays(names, holidays, changeHandlers) {
        const formats = {
            dataFormat: "DD/MM/YYYY",
            dateFormat: "DD/MM/YYYY",
            timeFormat: false,
        };
        const from = holidays && holidays.from ? holidays.from : "";
        const to = holidays && holidays.to ? holidays.to : "";
        return (
            <div className="display-flex align-center">
                <label htmlFor={"holidays"} className={"label-width"}>
                    {translator.translate("_holidays_")}:
                </label>
                <div className="display-flex my-custom-input margin-to-left">
                    {this.renderDateTimeInput(
                        "_start_",
                        names.from,
                        from,
                        formats,
                        changeHandlers.from,
                        (current) => {
                            const isValidDate = moment(to).isValid();
                            return !isValidDate || !to || current.isBefore(to);
                        }
                    )}
                    {this.renderDateTimeInput(
                        "_end_",
                        names.to,
                        to,
                        formats,
                        changeHandlers.to,
                        (current) => {
                            const isValidDate = moment(from).isValid();
                            return (
                                !isValidDate || !from || current.isAfter(from)
                            );
                        }
                    )}
                </div>
            </div>
        );
    }

    renderCheckboxGroup(title, index, checked, changeHandler) {
        return (
            <CheckboxGroup
                id={title}
                key={title}
                title={title}
                value={index}
                checked={checked}
                onChange={(e) => {
                    changeHandler(e, index);
                }}
                name={title}
                customClass="margin-to-right"
                customCheckboxClass="to-right"
            />
        );
    }

    renderNonWorkingDays(nonWorkingDays, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_non_working_days_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {NON_WORKING_DAYS.map((title, i) => {
                        return this.renderCheckboxGroup(
                            title,
                            i,
                            nonWorkingDays[i],
                            changeHandler
                        );
                    })}
                </div>
            </div>
        );
    }

    renderFromBackEntrance(checked, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_is_from_back_entrance_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={checked}
                        onChange={(e) => {
                            changeHandler(e);
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderIsPickupCooperation(checked, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_is_pickup_cooperation_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={checked}
                        onChange={(e) => {
                            changeHandler(e);
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderDistanceCalcDiscludedPartner(checked, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_distance_calc_discluded_partner_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={checked}
                        onChange={(e) => {
                            changeHandler(e);
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderHaysellRegion(label, name, value, validations, changeHandler) {
        return this.renderFormInput(
            label,
            name,
            value,
            validations,
            changeHandler
        );
    }
}

export default commonInformation;
